var map = {
	"./comunicado_20260605": 6,
	"./comunicado_20260605.jpeg": 6,
	"./comunicado_boleto": 7,
	"./comunicado_boleto.jpeg": 7,
	"./comunicado_pix": 8,
	"./comunicado_pix.jpeg": 8,
	"./comunicado_pix_2": 9,
	"./comunicado_pix_2.png": 9,
	"./logo": 10,
	"./logo.png": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;